import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";

import routes from "./routes";
import { estPagePublique } from "@/helpers/pagesPubliques";

Vue.use(VueRouter);

// Swallow harmless navigation failures (NavigationDuplicated / aborted /
// cancelled) so they don't surface as uncaught promise rejections in the
// dev-server error overlay. Real errors are still rejected.
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) {
      return err;
    }
    return Promise.reject(err);
  });
};

Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: "page",
});

const router = new VueRouter({
  routes,
  // Base = publicPath de vue.config.js ('/' a la racine de
  // app.evolisstructures.fr). Si l'app repasse un jour dans un
  // sous-dossier, c'est cette base qui evite que vue-router genere des URL
  // hors du sous-dossier (et qu'un F5 tombe ailleurs).
  base: process.env.BASE_URL,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: "history",
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  if (localStorage.getItem("auth") != null) {
    // Check if auth is required on this route
    // (including nested routes).
    // If auth isn't required for the route, just continue.
    next();
  } else {
    const authpage = !estPagePublique(routeTo.path);
    const loggeduser = localStorage.getItem("auth");
   
    
    if ( (authpage && !loggeduser ) ) {
      
      return next("/login");
    } else {
        
      if(!authpage && loggeduser==null){
         next();
      }
      next();
    }
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

export default router;
